<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { GetIndustryInfoList } from '@/api/industry'
import dayjs from 'dayjs'
export default {
  name: 'News',
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
      list: [],
      classOption: {
        singleHeight: 40,
        waitTime: 2000
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取资讯内容列表
    getList () {
      const params = {
        pageNum: 1,
        pageSize: 50,
        channelId: 13
      }
      GetIndustryInfoList(params).then(res => {
        if (res.code === 200) {
          this.list = res.data.data.resultData
        }
      })
    },
    formatTime (str, format = 'YYYY-MM-DD') {
      return dayjs(str).format(format)
    },
    goDetail (infoId) {
      window.open(`./RealtimeDetail?id=${infoId}`)
    }
  }
}
</script>

<template>
<div class="news">
  <header>
    <h2>布瑞克早报</h2>
  </header>
  <vue-seamless-scroll :data="list" class="warp" :class-option="classOption">
    <ul>
      <li class="item" v-for="(item, index) in list" :key="index" @click="goDetail(item.map.news.id)">
        <div class="news-label">[{{ item.map.news.labelName }}]</div>
        <div class="news-title">{{ item.map.news.title }}</div>
        <div class="news-time">{{ formatTime(item.map.news.created) }}</div>
      </li>
    </ul>
  </vue-seamless-scroll>

</div>
</template>

<style scoped lang="scss">
.news {
  width: 580px;
  height: 265px;
  padding: 20px;
  background-color: #fff;
  margin-left: 20px;
  h2 {
    color: #5D86D7;
  }
  .warp {
    height: 200px;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    ul {
      list-style: none;
      li {
        height: 40px;
        display: flex;
        font-size: 14px;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        &:hover {
          .news-title {
            color: #61a842;
          }
        }
        .news-label {
          color: #EE4533;
          font-weight: normal;
          flex: 0 0 100px;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Index/News.vue